export const materials = [
  {
    type: '军事毒剂',
    list: [
      { name: '塔崩', symbol: 'GA' },
      { name: '沙林', symbol: 'GB' },
      { name: '梭曼', symbol: 'GD' },
      { name: '维埃克斯', symbol: 'VX' },
      { name: '维埃斯', symbol: 'VS' },
      { name: '芥子气', symbol: 'HD' },
      { name: '路易氏剂', symbol: 'L' },
      { name: '氮芥', symbol: 'HN3' },
      { name: '氢氰酸', symbol: 'AC' },
      { name: '双光气', symbol: 'GC' },
      { name: '毕兹', symbol: 'BZ' },
      { name: '亚当氏剂', symbol: 'DM' },
      { name: '磷酸二甲酯', symbol: ' ' },
      { name: '硫二甘醇', symbol: ' ' },
      { name: '甲基膦酸二甲酯', symbol: ' ' },
      { name: '环沙林', symbol: ' ' }
    ]
  },
  {
    type: '工业毒气',
    list: [
      { name: '丙酮', symbol: 'Acetone' },
      { name: '氨气', symbol: 'NH3' },
      { name: '氯气', symbol: 'CI2' },
      { name: '甲苯', symbol: 'Toluene' },
      { name: '乙醇', symbol: 'Ethyl Alcohol' },
      { name: '间二甲苯', symbol: 'm-Xylene' },
      { name: '三氯乙烷', symbol: 'trichloroethane' },
      { name: '乙烷', symbol: 'C2H6' },
      { name: '硫化氢', symbol: 'H2S' },
      { name: '环氧乙烷', symbol: 'Epoxyethane' },
      { name: '一氧化氮', symbol: 'NO' },
      { name: '二氧化氮', symbol: 'NO2' },
      { name: '二氧化硫', symbol: 'SO2' },
      { name: '二氧化碳', symbol: 'CO2' },
      { name: '异丁烯', symbol: 'Isobutylene' },
      { name: '环己烷', symbol: 'Cyclohexane' },
      { name: '丙烯醛', symbol: 'Acrolein' },
      { name: '四氯乙烯', symbol: 'C2Cl4' },
      { name: '正丁醇', symbol: 'ButylAlcohol' },
      { name: '一氧化碳', symbol: 'CO' },
      { name: '氢气', symbol: 'H2' },
      { name: '氯化氢', symbol: 'HCL' },
      { name: '磷化氢', symbol: 'PH3' },
      { name: '氧气', symbol: 'O2' },
      { name: '臭氧', symbol: 'O3' },
      { name: '氰化氢', symbol: 'HCN' },
      { name: '氟气', symbol: 'F2' },
      { name: '二氧化氯', symbol: 'ClO2' },
      { name: '丁烷', symbol: 'C4H10' },
      { name: '乙醚', symbol: 'Ethyl' }
    ]
  },
  {
    type: '可燃气体及有机污染物',
    list: [
      { name: '甲烷', symbol: 'CH4' },
      { name: '苯', symbol: 'Benzen' },
      { name: '甲醇', symbol: 'Methanol' },
      { name: '乙炔', symbol: 'C2H2' },
      { name: '甲苯', symbol: 'Toluene' },
      { name: '环氧丙烷', symbol: 'PropyleneOxide' },
      { name: '苯胺', symbol: 'Aniline' },
      { name: '氯苯', symbol: 'LB' },
      { name: '乙醚', symbol: 'Ethyl' },
      { name: '苯乙烯', symbol: 'Styrene' },
      { name: '二甲胺', symbol: 'Dimethylamine' },
      { name: '甲苯二异氰酸酯', symbol: 'TD' },
      { name: '二硫化碳', symbol: 'CS2' },
      { name: '甲醚', symbol: 'Methylether' },
      { name: '环氧乙烷', symbol: 'Epoxyethane' },
      { name: '乙烷', symbol: 'C2H6' },
      { name: '氯乙烯', symbol: 'VinylChloride' },
      { name: '硝基苯', symbol: 'Nitrobenzene' },
      { name: '丙烯酸', symbol: 'Acrylicacid' },
      { name: '苯酚', symbol: 'Phenol' },
      { name: '汽油', symbol: 'Gasoline' },
      { name: '硫酸二甲酯', symbol: 'Dimethylsulfate' },
      { name: '环氧氯丙烷', symbol: 'Epichlorohydrin' },
      { name: '乙酸乙酯', symbol: 'EthylAcetate' },
      { name: '乙烯', symbol: 'C2H4' },
      { name: '甲基叔丁基醚', symbol: 'MTBE' },
      { name: '乙酸乙烯酯', symbol: 'Vinylacetate' },
      { name: '氯甲基甲醚', symbol: 'CME' },
      { name: '溴甲烷', symbol: 'Bromomethane' },
      { name: '乙酸', symbol: 'AceticAcid' },
      { name: '丙酮', symbol: 'Acetone' },
      { name: '丙烷', symbol: 'C3H8' },
      { name: '乙苯', symbol: 'Ethylbenzene' },
      { name: '三氯乙烯', symbol: 'Trichloroethylene' },
      { name: '戊烷', symbol: 'C5H12' },
      { name: '正庚烷', symbol: 'C7H16' },
      { name: '二甲苯', symbol: 'Xylenes' },
      { name: '己烷', symbol: 'Hexane' },
      { name: '对硝基苯胺（）', symbol: 'Nitroaniline' },
      { name: '氟乙酸', symbol: 'fluoroaceticacid' },
      { name: '敌敌畏', symbol: 'DDVP' },
      { name: '2-丁酮', symbol: '2Butanone' },
      { name: '氯乙酸', symbol: 'Chloroacetic' },
      { name: '异丙醇', symbol: 'Isopropanol' },
      { name: '丙烯', symbol: 'C3H6' },
      { name: '丁烷', symbol: 'C4H10' },
      { name: '1,1-二氯乙烷', symbol: '11ELYW' },
      { name: '六氟化硫', symbol: 'SF6' },
      { name: '甲硫醚', symbol: 'C2H6S' },
      { name: '异丁烯', symbol: 'Isobutylene' },
      { name: '辛烷', symbol: 'NOCTANE' },
      { name: '壬烷', symbol: 'Nonane' },
      { name: '癸烷', symbol: 'Decane' },
      { name: '环戊烷', symbol: 'Cyclopentane' },
      { name: '环己烷', symbol: 'Cyclohexane' },
      { name: '111三氟丙酮', symbol: '111Trichloroacetone' },
      { name: '二甲基二硫醚', symbol: 'DimethylDisulfide' },
      { name: '甲硫醇', symbol: 'Methanethiol' },
      { name: '邻氯甲苯', symbol: 'OChlorotoluene' },
      { name: '3氯甲苯', symbol: '3Chlorotoluene' },
      { name: '苄基氯', symbol: 'C7H7Cl' },
      { name: '正丁醇', symbol: 'ButylAlcohol' },
      { name: '异丙醚', symbol: 'Isopropylether' },
      { name: '碳酸二甲酯', symbol: 'DMC' },
      { name: '乙酸甲酯', symbol: 'Methylacetate' },
      { name: '丙烯酸甲酯', symbol: 'Methylacrylate' },
      { name: '二甲氧基甲烷', symbol: 'Dimethoxymethane' },
      { name: '四氯乙烯', symbol: 'C2Cl4' },
      { name: '三乙胺', symbol: 'Et3N' },
      { name: '三甲胺', symbol: 'TMA' },
      { name: '苯甲醛', symbol: 'Benzaldehyde' },
      { name: '氯化亚砜', symbol: 'SOCl2' },
      { name: '环庚烷', symbol: 'C7H14' },
      { name: '异丙苯', symbol: 'Cumene' },
      { name: '丙醇', symbol: 'Propanol' },
      { name: '庚醇', symbol: 'Heptanol' },
      { name: '环己醇', symbol: 'Cyclohexanol' },
      { name: '双丙酮醇', symbol: 'Diacetonealcohol' },
      { name: '2戊酮', symbol: '2Pentanone' },
      { name: '四氢萘', symbol: 'C10H12' },
      { name: '12二溴四氟乙烷', symbol: 'Exsfyw' },
      { name: '2甲基戊烷', symbol: '2Methylpentane' },
      { name: '乙二醇二甲醚', symbol: '12Dimethoxyethane' },
      { name: '135三甲苯', symbol: 'Mesitylene' },
      { name: '溴代丙烷', symbol: '1Bromopropane' },
      { name: '氯代异丁烷', symbol: 'C4H9Cl' },
      { name: '1氯丁烷', symbol: 'Chlorobutane' },
      { name: '1氯戊烷', symbol: 'Chloropentane' },
      { name: '1硝基丙烷', symbol: 'Nitropropane' },
      { name: '1辛烯', symbol: '1Octene' },
      { name: '222三氟乙醇', symbol: 'Trifluoroethanol' },
      { name: '二异丁烯', symbol: 'EYDX' },
      { name: '23二氯丙烯', symbol: 'ELBX' },
      { name: '23二甲基丁烷', symbol: 'EJJDW' },
      { name: '26二甲苯胺', symbol: 'Dimethylaniline' },
      { name: '2溴丙烷', symbol: 'Bromopropane' },
      { name: '乙二醇乙醚乙酸酯', symbol: 'C6H12O3' },
      { name: '邻乙基甲苯', symbol: 'oEthyltoluene' },
      { name: '2氟乙醇', symbol: 'Fluoroethanol' },
      { name: '2己醇', symbol: '2Hexanol' },
      { name: '异丁醛', symbol: 'Isobutyraldehyde' },
      { name: '异丁硫醇', symbol: 'C4H10S' },
      { name: '2甲基丙烯醛', symbol: 'Methacrylaldehyde' },
      { name: '异丁烯 ', symbol: 'C4H8' },
      { name: '乙醇', symbol: 'C2H6O' },
      { name: '丙酮', symbol: 'C3H6O' },
      { name: '苯', symbol: 'C6H6' },
      { name: '二甲苯', symbol: 'C8H10' },
      { name: '三甲苯', symbol: 'C9H12' },
      { name: '氯乙烯', symbol: 'C2H3Cl' },
      { name: '乙酸乙烯酯', symbol: 'C4H6O2' },
      { name: '三氯乙烯', symbol: 'C2HCl3' },
      { name: '四氢呋喃', symbol: 'C4H8O' },
      { name: '沙林', symbol: 'C4H10O2PF' },
      { name: '塔崩', symbol: 'C5H11N2O2P' },
      { name: '芥子气', symbol: 'C4H8Cl2S' },
      { name: '四氯乙烯', symbol: 'C2Cl4' },
      { name: '苯乙烯', symbol: 'C8H8' },
      { name: '吡啶', symbol: 'C5H5N' },
      { name: '乙酸丙酯', symbol: 'C5H10O2' },
      { name: '丙酸', symbol: 'C3H6O2' },
      { name: '丙醇', symbol: 'C3H8O' },
      { name: '三氯化磷', symbol: 'PCl3' },
      { name: '苯酚', symbol: 'C6H6O' },
      { name: '正戊烷', symbol: 'C5H12' },
      { name: '3-戊酮', symbol: 'C5H10O' },
      { name: '五羰基铁', symbol: 'FeC5O5' },
      { name: '石蜡', symbol: '' },
      { name: '正辛烷', symbol: 'C8H18' },
      { name: '正壬烷', symbol: 'C9H20' },
      { name: '二氧化氮', symbol: 'NO2' },
      { name: '硝基苯', symbol: 'C6H5NO2' },
      { name: '萘', symbol: 'C10H8' },
      { name: '吗啡啉', symbol: 'C4H9NO' },
      { name: '异丙叉丙酮', symbol: 'C6H10O' },
      { name: '5-甲基-3-庚酮', symbol: 'C8H16O' },
      { name: '甲胺', symbol: 'CH5N' },
      { name: '甲基叔丁基醚', symbol: 'C5H12O' },
      { name: '甲基丙烯酸甲酯', symbol: 'C5H8O2' },
      { name: '甲硫醇', symbol: 'CH4S' },
      { name: '异氰酸甲酯', symbol: 'C2H3NO' },
      { name: '甲基乙基酮', symbol: 'C4H8O' },
      { name: '丙烯酸甲酯', symbol: 'C4H6O2' },
      { name: '乙酸甲酯', symbol: 'C3H6O2' },
      { name: '2-甲氧基乙酸乙酯', symbol: 'C5H10O3' },
      { name: '乙二醇甲醚', symbol: 'C3H8O2' },
      { name: '甲醇', symbol: 'CH4O' },
      { name: '甲基丙烯腈', symbol: 'C4H5N' },
      { name: '甲基丙烯酸', symbol: 'C4H6O2' },
      { name: '顺丁烯二酸酐', symbol: 'C4H2O3' },
      { name: '乙烯酮', symbol: 'C2H2O' },
      { name: '异丙胺', symbol: 'C3H9N' },
      { name: '异丙醇', symbol: 'C3H8O' },
      { name: '碘甲烷', symbol: 'CH3I' },
      { name: '碘仿', symbol: 'CHI3' },
      { name: '茚', symbol: 'C9H8' },
      { name: '硒化氢', symbol: 'H2Se' },
      { name: '肼', symbol: 'H4N2' },
      { name: '2-己酮', symbol: 'C6H12O' },
      { name: '锗烷', symbol: 'GeH4' },
      { name: '糠醇', symbol: 'C5H6O2' },
      { name: '糠醛', symbol: 'C5H4O2' },
      { name: '呋喃', symbol: 'C4H4O' },
      { name: '乙二胺', symbol: 'C2H8N2' },
      { name: '乙二醇', symbol: 'C2H6O2' },
      { name: '乙苯', symbol: 'C8H10' },
      { name: '乙胺', symbol: 'C2H7N' },
      { name: 'N-乙基吗啉', symbol: 'C6H13NO' },
      { name: '乙硫醇', symbol: 'C2H6S' },
      { name: '乙酸乙酯', symbol: 'C4H8O2' },
      { name: '乙二醇乙醚', symbol: 'C4H10O2' },
      { name: '乙醇胺', symbol: 'C2H7NO' },
      { name: '环氧氯丙烷', symbol: 'C3H5ClO' },
      { name: '二乙烯苯', symbol: 'C10H10' },
      { name: '二苯醚', symbol: 'C12H10O' },
      { name: '1,4-二氧六环', symbol: 'C4H8O2' },
      { name: '二甲基肼', symbol: 'C2H8N2' },
      { name: '乙酸4-甲基-2-戊酯', symbol: 'C8H16O2' },
      { name: 'N,N-二甲基苯胺', symbol: 'C8H11N' },
      { name: '二甲胺', symbol: 'C2H7N' },
      { name: 'N,N-二甲基乙酰胺', symbol: 'C4H9NO' },
      { name: '二甲基亚砜', symbol: 'C2H6OS' },
      { name: '甲缩醛', symbol: 'C3H8O' },
      { name: '二缩水甘油醚', symbol: 'C6H10O3' },
      { name: '二乙烯三胺', symbol: 'C4H13N3' },
      { name: '二乙氨基乙醇', symbol: 'C6H15NO' },
      { name: '二氯甲烷', symbol: 'CH2Cl2' },
      { name: '顺-1,2-二氯乙烯', symbol: 'C2H2Cl2' },
      { name: '1,4-二氯苯', symbol: 'C6H4Cl2' },
      { name: '邻二氯苯', symbol: 'C6H4Cl2' },
      { name: '1,3-二氯-1-丙烯', symbol: 'C3H4Cl2' },
      { name: '萘烷', symbol: 'C10H18' },
      { name: '环己胺', symbol: 'C6H13N' },
      { name: '环己酮', symbol: 'C6H10O' },
      { name: '环己醇', symbol: 'C6H12O' },
      { name: '环己烷', symbol: 'C6H12' },
      { name: '2-氯苯乙烯', symbol: 'C8H7Cl' },
      { name: '2-氯-1,3-丁二烯', symbol: 'C4H5Cl' },
      { name: '氯苯', symbol: 'C6H5Cl' },
      { name: '二硫化碳', symbol: 'CS2' },
      { name: '丁醛', symbol: 'C4H8O' },
      { name: '邻仲丁基苯酚', symbol: 'C10H14O' },
      { name: '乳酸丁酯', symbol: 'C7H14O3' },
      { name: '正丁基缩水甘油醚', symbol: 'C7H14O2' },
      { name: '丙烯酸正丁酯', symbol: 'C7H12O2' },
      { name: '乙酸丁酯', symbol: 'C6H12O2' },
      { name: '乙二醇丁醚', symbol: 'C6H14O2' },
      { name: '正丁醇', symbol: 'C4H10O' },
      { name: '丁二烯', symbol: 'C4H6' },
      { name: '溴丙烷', symbol: 'C3H7Br' },
      { name: '溴仿', symbol: 'CHBr3' },
      { name: '液溴', symbol: 'Br2' },
      { name: '联苯', symbol: 'C12H10' },
      { name: '苯胺', symbol: 'C6H7N' },
      { name: '乙酸戊酯', symbol: 'C7H14O2' },
      { name: '氨', symbol: 'NH3' },
      { name: '氯丙烯', symbol: 'C3H5Cl' },
      { name: '丙烯醇', symbol: 'C3H6O' },
      { name: '丙烯酸', symbol: 'C3H4O2' },
      { name: '乙酸酐', symbol: 'C4H6O3' },
      { name: '醋酸', symbol: 'C2H4O2' },
      { name: '松节油', symbol: 'C10H16' },
      { name: '甲苯', symbol: 'C7H8' },
      { name: 'S-三聚硫代甲', symbol: 'C3H6S3' },
      { name: '2-氨基吡啶', symbol: 'C5H6N2' },
      { name: '环氧丙烷', symbol: 'C3H6O' },
      { name: '溴甲烷', symbol: 'CH3Br' },
      { name: '二丙二醇甲醚', symbol: 'C7H16O3' },
      { name: '异佛尔酮二异氰酸酯', symbol: 'C12H18N2O2' },
      { name: '1,6-己二异氰酸酯', symbol: 'C8H12N2O2' },
      { name: '环氧乙烷', symbol: 'C2H4O' },
      { name: '乙二醇乙醚醋酸酯', symbol: 'C6H12O3' },
      { name: '二异丁基酮', symbol: 'C9H18O' },
      { name: '间苯二酚', symbol: 'C6H6O2' },
      { name: '乙醚', symbol: 'C4H10O' },
      { name: '二聚环戊二烯', symbol: 'C10H12' },
      { name: '二丙酮醇', symbol: 'C6H12O2' },
      { name: '四溴化碳', symbol: 'CBr4' },
      { name: '丁硫醇', symbol: 'C4H10S' },
      { name: '对苯醌', symbol: 'C6H4O2' },
      { name: '正戊醇', symbol: 'C5H12O' },
      { name: '甲苯-2,4-二异氰酸酯', symbol: 'C9H6N2O2' },
      { name: '对二甲苯', symbol: 'C8H10' },
      { name: '邻二甲苯', symbol: 'C8H10' },
      { name: '间二甲苯', symbol: 'C8H10' },
      { name: '乙烯基硅烷', symbol: 'C2H6Si' },
      { name: '4-乙烯基环己烯', symbol: 'C8H12' },
      { name: '氟化乙烯', symbol: 'C2H3F' },
      { name: '溴乙烯', symbol: 'C2H3Br' },
      { name: '乙酸乙烯酯', symbol: 'C4H6O2' },
      { name: '香兰素', symbol: 'C8H8O3' },
      { name: '十一烷', symbol: 'C11H24' },
      { name: '三聚甲醛', symbol: 'C3H4O3' },
      { name: '三甲基硅烷', symbol: 'C3H10Si' },
      { name: '氧杂环丁烷', symbol: 'C3H6O' },
      { name: '1,2,4-三甲基环己烷', symbol: 'C9H18' },
      { name: '硼酸三甲酯', symbol: 'C3H9FBO3' },
      { name: '三甲胺', symbol: 'C3H9N' },
      { name: '乙烯基三甲氧基硅烷', symbol: 'C5H12O3Si' },
      { name: '2,2,2-三氟乙基甲基醚', symbol: 'C3H5F3O' },
      { name: '三氟乙烯', symbol: 'C2HF2' },
      { name: '三乙基铝', symbol: 'C6H15Al' },
      { name: '三乙基苯', symbol: 'C12H18' },
      { name: '三乙胺', symbol: 'C6H15N' },
      { name: '三乙基硅烷', symbol: 'C2H6Si' },
      { name: '亚磷酸三乙酯', symbol: 'C6H15O3' },
      { name: '磷酸三乙酯', symbol: 'C6H15O4P' },
      { name: '1,2,4-三氯苯', symbol: 'C6H3Cl3' },
      { name: '三正丁胺', symbol: 'C12H27N' },
      { name: '磷酸三丁酯', symbol: 'C12H27O4P' },
      { name: '1,3,5-三嗪', symbol: 'C3H3N3' },
      { name: '对甲基苯甲醛', symbol: 'C8H8O' },
      { name: '邻甲苯胺', symbol: 'C7H9N' },
      { name: '对甲苯磺酰氯', symbol: 'C7H7SO2Cl' },
      { name: '钛酸正丙酯', symbol: 'C12H28O4Ti' },
      { name: '百里酚', symbol: 'C10H14O' },
      { name: '硫光气', symbol: 'CS2Cl' },
      { name: '噻吩', symbol: 'C4H4S' },
      { name: '硫氰', symbol: 'C2S2N2' },
      { name: '硫代乙酸', symbol: 'C2H4OS' },
      { name: '四甲基硅烷', symbol: 'C4H12Si' },
      { name: '四甲基胍', symbol: 'C5H13N3' },
      { name: '六甲基乙烷', symbol: 'C8H18' },
      { name: '1,2,4,5-四甲苯', symbol: 'C10H14' },
      { name: '四甲基琥珀腈', symbol: 'C8H12N2' },
      { name: '正硅酸甲酯', symbol: 'C4H12O4Si' },
      { name: '四氢噻吩', symbol: 'C4H8S' },
      { name: '四氢吡喃', symbol: 'C5H10O' },
      { name: '1,2,3,4-四氢萘', symbol: 'C10H12' },
      { name: '四氟乙烯', symbol: 'C2F4' },
      { name: '硅酸乙酯', symbol: 'C8H20O4Si' },
      { name: '四氯吡啶', symbol: 'C5HNCl4' },
      { name: '羰基镍', symbol: 'NiC4O4' },
      { name: '甲酸叔丁酯', symbol: 'C5H10O2' },
      { name: '溴代叔丁烷', symbol: 'C4H9Br' },
      { name: '叔丁醇', symbol: 'C4H10O' },
      { name: '甲基叔戊基醚', symbol: 'C6H14O' },
      { name: '乙酸松油酯', symbol: 'C12H20O2' },
      { name: '萜品油烯', symbol: 'C10H16' },
      { name: '四氢吡咯', symbol: 'C4H9N' },
      { name: '吡咯', symbol: 'C4H5N' },
      { name: '4-羟基吡啶', symbol: 'C5H5NO' },
      { name: '吡嗪', symbol: 'C4H4N2' },
      { name: '丙炔', symbol: 'C5H4' },
      { name: '1(或2)-乙氧基丙醇乙酸酯', symbol: 'C7H14O3' },
      { name: '碳酸丙烯酯', symbol: 'C4H6O3' },
      { name: '丙基苯', symbol: 'C9H12' },
      { name: '正丙胺', symbol: 'C3H9N' },
      { name: '甲酸丙酯', symbol: 'C4H8O2' },
      { name: '丁酸丙酯', symbol: 'C7H14O2' },
      { name: '1-丙氧基-2-丙醇', symbol: 'C6H14O2' },
      { name: '丙醛', symbol: 'C3H6O' },
      { name: '丙炔酸', symbol: 'C3H2O3' },
      { name: '丙烯', symbol: 'C3H6' },
      { name: '2-丙烯-1-亚胺', symbol: 'C3H5N' },
      { name: '丙酰胺', symbol: 'C3H7NO2' },
      { name: '哌啶', symbol: 'C5H11N' },
      { name: '哌嗪', symbol: 'C4H10N2' },
      { name: 'β-蒎烯', symbol: 'C10H16' },
      { name: 'α-蒎烯', symbol: 'C10H16' },
      { name: 'β-蒎烯', symbol: 'C10H16' },
      { name: '2-蒎烯', symbol: 'C10H16' },
      { name: '3-甲基吡啶', symbol: 'C6H7N' },
      { name: '磷化氢', symbol: 'PH3' },
      { name: '乙酸苏合香酯', symbol: 'C10H12O2' },
      { name: '环己基苯', symbol: 'C12H16' },
      { name: '苯乙酸', symbol: 'C8H8O2' },
      { name: '苯乙醛', symbol: 'C8H8O' },
      { name: '苯基缩水甘油醚', symbol: 'C9H10O2' },
      { name: 'α-甲基苯乙烯', symbol: 'C9H10' },
      { name: '异丁酸苯乙酯', symbol: 'C12H16O2' },
      { name: '氯甲酸苯酯', symbol: 'C7H5ClO2' },
      { name: '乙二醇苯醚', symbol: 'C8H10O2' },
      { name: '甲基苯乙基醚', symbol: 'C9H12O' },
      { name: '水芹烯', symbol: 'C10H16' },
      { name: '六氟-1,3-丁二烯', symbol: 'C4F6' },
      { name: '过氧乙酸', symbol: 'C2H4O3' },
      { name: '1-戊炔', symbol: 'C5H8' },
      { name: '戊基环戊烷', symbol: 'C10H20' },
      { name: '2-戊基环戊酮', symbol: 'C10H18O' },
      { name: '1-戊烯', symbol: 'C6H12' },
      { name: '3-戊醇', symbol: 'C5H12O' },
      { name: '正戊酸', symbol: 'C5H10O2' },
      { name: '乙酰丙酮', symbol: 'C5H8O2' },
      { name: '戊醛', symbol: 'C5H10O' },
      { name: '2-戊酮', symbol: 'C5H10O' },
      { name: '三聚乙醛', symbol: 'C6H12O3' },
      { name: '二乙二醇', symbol: 'C4H10O3' },
      { name: '草酰溴', symbol: 'C2Br2O2' },
      { name: '1-辛烯', symbol: 'C8H16' },
      { name: '辛烯', symbol: 'C8H16' },
      { name: '正辛醇', symbol: 'C8H18O' },
      { name: '八甲基三硅氧烷', symbol: 'C8H24O2Si3' },
      { name: '八甲基环四硅氧烷', symbol: 'C8H24O4Si4' },
      { name: '二环庚二烯', symbol: 'C7H8' },
      { name: '壬烯', symbol: 'C9H18' },
      { name: '壬烯', symbol: 'C9H18' },
      { name: '1-壬醇', symbol: 'C9H20O' },
      { name: 'N-羟甲基丙烯酰胺', symbol: 'C4H7NO2' },
      { name: '氧化亚氮', symbol: 'N2O' },
      { name: '烟碱，尼古丁', symbol: 'C10H14N2' },
      { name: '2,2-二甲基丙醇', symbol: 'C5H12O' },
      { name: '新戊烷', symbol: 'C5H12' },
      { name: '石油醚', symbol: 'CnH(2n+2)' },
      { name: '月桂烯', symbol: 'C10H16' },
      { name: '2-氨基-2-甲基-1-丙醇', symbol: 'C4H11NO' },
      { name: '矿物油', symbol: '' },
      { name: '3-甲硫基丙醛', symbol: 'C4H8OS' },
      { name: '乙烯基甲苯', symbol: 'C9H10' },
      { name: 'N-甲基吡咯', symbol: 'C5H7N' },
      { name: '异丁酰氯', symbol: 'C4H7ClO' },
      { name: '2-甲基-2,4-戊二醇', symbol: 'C6H14O2' },
      { name: '3-甲基苯酚甲酯', symbol: 'C6H14' },
      { name: '异己烷', symbol: 'C6H14' },
      { name: '甲基异丁基甲醇', symbol: 'C6H14O' },
      { name: '一甲肼', symbol: 'CH6N2' },
      { name: '5-甲基-2-己酮', symbol: 'C7H14O' },
      { name: '2-乙基-1-丁烯', symbol: 'C6H12' },
      { name: '甲基环戊烷', symbol: 'C6H12' },
      { name: '2-甲基环己酮', symbol: 'C7H12O' },
      { name: '4-甲基环己醇', symbol: 'C7H14O' },
      { name: '甲基环己醇', symbol: 'C7H14O' },
      { name: '甲基环己烷', symbol: 'C7H14' },
      { name: '2-甲基丁酸', symbol: 'C5H10O2' },
      { name: '2-甲基丁醇', symbol: 'C5H12O' },
      { name: '2-甲基丁醛', symbol: 'C5H10O' },
      { name: '异戊醇', symbol: 'C5H12O' },
      { name: '甲基庚烯酮', symbol: 'C8H14O' },
      { name: 'N-甲基吡咯烷酮', symbol: 'C5H9NO' },
      { name: '2-甲基烯丙醇', symbol: 'C4H8O' },
      { name: '2E)-3-甲基己-2-烯酸', symbol: 'C7H12O2' },
      { name: '2-戊醇', symbol: 'C5H12O' },
      { name: '异戊烯', symbol: 'C5H10' },
      { name: '甲基乙烯基甲酮', symbol: 'C4H6O' },
      { name: '2-甲基十一醛', symbol: 'C12H24O' },
      { name: '巯基乙酸甲酯', symbol: 'C3H6O2S' },
      { name: '硫氰酸甲酯', symbol: 'C2H3NS' },
      { name: '二甲基硫', symbol: 'C2H6S' },
      { name: '水杨酸甲酯', symbol: 'C8H8O3' },
      { name: '甲基丙烯酸酯', symbol: 'C4H4O2' },
      { name: '丙酸甲酯', symbol: 'C4H8O2' },
      { name: '甲基炔丙基醚', symbol: 'C4H6O' },
      { name: '苯乙酸甲酯', symbol: 'C9H10O2' },
      { name: '异硫氰酸甲酯', symbol: 'C2H3NS' },
      { name: '硫代异氰酸甲酯', symbol: 'C2H3NS' },
      { name: '甲基紫罗兰酮', symbol: 'C14H22O' },
      { name: '苯甲酸甲酯', symbol: 'C8H8O2' },
      { name: '乙酰乙酸甲酯', symbol: 'C5H8O3' },
      { name: '异丁酸甲酯', symbol: 'C5H10O2' },
      { name: '甲基丙基醚', symbol: 'C4H10O' },
      { name: '丙二醇甲醚', symbol: 'C4H10O2' },
      { name: '二乙二醇甲醚', symbol: 'C5H12O3' },
      { name: '乙烯基甲醚', symbol: 'C3H6O' },
      { name: '甲乙醚', symbol: 'C3H8O' },
      { name: '1-甲氧基-2,2-二甲基丙烷', symbol: 'C6H14O' },
      { name: '(2S)-2-甲氧基-1-丙醇', symbol: 'C4H10O2' },
      { name: '甲基丙烯酰胺', symbol: 'C4H7NO' },
      { name: '低聚乙醛', symbol: 'C8H16O4' },
      { name: '巯基乙酸', symbol: 'C2H4O2S' },
      { name: '胡薄荷酮', symbol: 'C10H18O' },
      { name: '薄荷脑', symbol: 'C10H20O' },
      { name: '乙酸芳樟酯', symbol: 'C12H20O2' },
      { name: '2,2,6-三甲基-6-乙烯基四氢-2H-呋喃-3-醇', symbol: 'C10H18O2' },
      { name: '茉莉酮', symbol: 'C11H16O' },
      { name: '异恶唑', symbol: 'C3H3NO' },
      { name: '异戊酸', symbol: 'C5H10O2' },
      { name: '异戊醛', symbol: 'C5H10O' },
      { name: '异噻唑', symbol: 'C3H3NS' },
      { name: '异黄樟素', symbol: 'C10H10O2' },
      { name: '异丙基环己烷', symbol: 'C9H18' },
      { name: '2-(异丙基氨)乙醇', symbol: 'C5H13NO' },
      { name: '亚硝酸异丙酯', symbol: 'C3H7NO2' },
      { name: '氯甲酸异丙酯', symbol: 'C4H7O2Cl' },
      { name: '乙酸异丙酯', symbol: 'C5H10O2' },
      { name: '异丙氧基乙醇', symbol: 'C5H12O2' },
      { name: '异戊二烯', symbol: 'C5H8' },
      { name: '异佛尔酮', symbol: 'C9H14O' },
      { name: '异戊烷', symbol: 'C5H12' },
      { name: '异辛醇', symbol: 'C8H18O' },
      { name: '(+)-异薄荷酮', symbol: 'C10H18O' },
      { name: '二氢茉莉酮', symbol: 'C11H18O' },
      { name: '2-甲基已烷(异庚烷)', symbol: 'C7H16' },
      { name: '异丁香酚', symbol: 'C10H12O2' },
      { name: '异癸醇', symbol: 'C10H22O' },
      { name: '异丁酸', symbol: 'C4H8O2' },
      { name: '异丁醛', symbol: 'C4H8O' },
      { name: '甲基环氧丙烷', symbol: 'C4H8O' },
      { name: '异丁基苯', symbol: 'C10H14' },
      { name: '丙烯酸异丁酯', symbol: 'C7H12O2' },
      { name: '乙酸异丁酯', symbol: 'C6H12O2' },
      { name: '异丁醇', symbol: 'C4H10O' },
      { name: '异丁烷', symbol: 'C4H10' },
      { name: '水杨酸异戊酯', symbol: 'C12H16O3' },
      { name: '乙酸异戊酯', symbol: 'C7H14O2' },
      { name: '醋酸异戊酯', symbol: 'C7H14O2' },
      { name: '碘化乙烯', symbol: 'C2H3I' },
      { name: '碘苯', symbol: 'C5H5I' },
      { name: '碘', symbol: 'I2' },
      { name: '吲哚', symbol: 'C8H7N' },
      { name: '2-丙烯酸-2-羟基丙基酯', symbol: 'C6H10O3' },
      { name: '羟胺', symbol: 'H3NO' },
      { name: '丙烯酸羟乙酯', symbol: 'C5H8O3' },
      { name: '3-羟基丁醛', symbol: 'C4H8O2' },
      { name: '碲化氢', symbol: 'H2Te' },
      { name: '硫化氢', symbol: 'H2S' },
      { name: '氢碘酸', symbol: 'HI' },
      { name: '正己醛', symbol: 'C6H12O' },
      { name: '顺-3-己烯基丁酯', symbol: 'C10H18O2' },
      { name: '乙酸叶醇酯', symbol: 'C8H14O2' },
      { name: '1-己烯', symbol: 'C6H12' },
      { name: '正己醇', symbol: 'C6H14O' },
      { name: '正己酸', symbol: 'C6H12O2' },
      { name: '正己烷', symbol: 'C6H14' },
      { name: '六甲基二硅氧烷', symbol: 'C6H18OSi2' },
      { name: '六甲基二硅氮烷', symbol: 'C6H19NSi2' },
      { name: '六氯乙硅烷', symbol: 'Cl6Si' },
      { name: '1-己烯-3-醇', symbol: 'C6H12O' },
      { name: '1-庚炔', symbol: 'C7H12' },
      { name: '2-庚基环戊酮', symbol: 'C12H22O' },
      { name: '1-庚烯', symbol: 'C7H14' },
      { name: '庚醇', symbol: 'C7H16O' },
      { name: '庚烷', symbol: 'C7H16' },
      { name: '3-庚酮', symbol: 'C7H14O' },
      { name: '2-庚酮', symbol: 'C7H14O' },
      { name: '乙二醛', symbol: 'C2H2O2' },
      { name: '羟乙醛', symbol: 'C2H4O2' },
      { name: '甲基丙烯酸缩水甘油酯', symbol: 'C7H10O3' },
      { name: '戊二醛', symbol: 'C5H8O2' },
      { name: '乙酸香叶酯', symbol: 'C12H20O2' },
      { name: '香叶醇', symbol: 'C10H18O' },
      { name: '(E)-3,7-二甲基-2,6-辛二烯醛', symbol: 'C10H16O' },
      { name: '糠(基)硫醇', symbol: 'C5H6OS' },
      { name: '甲酰胺', symbol: 'CH3ON' },
      { name: '对氟苯甲酸', symbol: 'C7H5FO2' },
      { name: '氟苯', symbol: 'C6H5F' },
      { name: '二茂铁', symbol: 'C10H10Fe' },
      { name: '葑醇', symbol: 'C10H18O' },
      { name: '丁香酚', symbol: 'C10H12O2' },
      { name: '异辛酸', symbol: 'C8H16O2' },
      { name: '2-乙基已基醛', symbol: 'C8H16O' },
      { name: '乙二醇二乙酸酯', symbol: 'C6H10O4' },
      { name: '碳酸乙烯酯', symbol: 'C3H4O3' },
      { name: '乙烯', symbol: 'C2H4' },
      { name: '乙基环己烷', symbol: 'C8H16' },
      { name: '1-丁炔', symbol: 'C4H6' },
      { name: '3-乙氧基丙酸乙酯', symbol: 'C7H14O3' },
      { name: '邻乙基甲苯', symbol: 'C9H12' },
      { name: '叔丁基乙醚', symbol: 'C6H14O' },
      { name: '硅酸乙酯', symbol: 'C8H20O4Si' },
      { name: '丙酸乙酯', symbol: 'C5H10O2' },
      { name: '苯乙酸乙酯', symbol: 'C10H12O2' },
      { name: '碳酸甲乙酯', symbol: 'C4H8O3' },
      { name: '甲基丙烯酸乙酯', symbol: 'C6H10O2' },
      { name: '乳酸乙酯', symbol: 'C5H10O3' },
      { name: '2-甲基-3-戊酮', symbol: 'C6H12O' },
      { name: '碘乙烷', symbol: 'C2H5I' },
      { name: '丙烯酸异辛酯', symbol: 'C11H20O2' },
      { name: '异辛醇', symbol: 'C8H18O' },
      { name: '己酸乙酯', symbol: 'C8H16O2' },
      { name: '甲酸乙酯', symbol: 'C3H6O2' },
      { name: '氰基丙烯酸乙酯', symbol: 'C6H7O2N' },
      { name: '氯甲酸乙酯', symbol: 'C3H5O2Cl' },
      { name: '丁酸乙酯', symbol: 'C6H12O2' },
      { name: '苯甲酸乙酯', symbol: 'C9H10O2' },
      { name: '丙烯酸乙酯', symbol: 'C5H8O2' },
      { name: '乙酰乙酸乙酯', symbol: 'C6H10O3' },
      { name: '2-甲基丁酸乙酯', symbol: 'C7H14O2' },
      { name: '乙基丁基醚', symbol: 'C6H14O' },
      { name: '1-乙氧基-2-丙醇', symbol: 'C5H10O2' },
      { name: '异丁醚', symbol: 'C6H14O' },
      { name: '草蒿脑', symbol: 'C10H12O' },
      { name: '异丙基缩水甘油醚', symbol: 'C6H12O2' },
      { name: '正十二烷', symbol: 'C12H36' },
      { name: '间二乙烯基苯', symbol: 'C10H10' },
      { name: '氯化硫', symbol: 'S2Cl2' },
      { name: '溴化硫', symbol: 'S2Br2' },
      { name: '乙硅烷', symbol: 'Si2H6' },
      { name: '丙醚', symbol: 'C6H14O' },
      { name: '1,3-二氧戊环', symbol: 'C3H6O2' },
      { name: '二正丙胺', symbol: 'C6H15N' },
      { name: '二正丁胺', symbol: 'C8H19N' },
      { name: '二甲基硫代磷酰氯', symbol: 'C2H6ClO2PS' },
      { name: '顺式-1,2-二甲基环戊烷', symbol: 'C7H14' },
      { name: '1,2-二甲基环乙烷', symbol: 'C8H16' },
      { name: '二甲基溴化硼', symbol: 'C2H6BBr' },
      { name: 'N,N-二甲基乙醇胺', symbol: 'C4H11NO' },
      { name: '2-丁炔', symbol: 'C4H6' },
      { name: '邻苯二甲酸二甲酯', symbol: 'C10H10O4' },
      { name: '亚磷酸二甲酯', symbol: 'C2H7O3P' },
      { name: '乙硫醚', symbol: 'C4H10S' },
      { name: '硫酸二乙酯', symbol: 'C4H10SO4' },
      { name: '二氯乙烯', symbol: 'C2H2Cl2' },
      { name: '1,1-二氯乙烯', symbol: 'C2H2Cl2' },
      { name: '二氯乙炔', symbol: 'C2Cl2' },
      { name: '1,1-二氯-2,2-二氟乙烯', symbol: 'C2H2Cl2F2' },
      { name: '1,2-二氯-1,2-二氟乙烯', symbol: 'C2Cl2F2' },
      { name: '癸醛', symbol: 'C10H20O' },
      { name: '4-异丙基甲苯', symbol: 'C10H14' },
      { name: '环庚烷', symbol: 'C7H14' },
      { name: '環丁烯', symbol: 'C4H6' },
      { name: '环丁酮', symbol: 'C4H6O' },
      { name: '异丙苯', symbol: 'C9H12' },
      { name: '巴豆醇', symbol: 'C4H8O' },
      { name: '巴豆醛', symbol: 'C4H6O' },
      { name: '对甲苯甲醚', symbol: 'C8H10O' },
      { name: '2-氯丁烷', symbol: 'C4H9Cl' },
      { name: '氯丁烷', symbol: 'C4H9Cl' },
      { name: '一氯乙醛', symbol: 'C2H3OCl' },
      { name: '2-氯-1,1-二氟乙烯', symbol: 'C2H3ClF2' },
      { name: '叔丁胺', symbol: 'C4H11N' },
      { name: '(S)-2-氨基丁烷', symbol: 'C4H11N' },
      { name: '正丁胺', symbol: 'C4H11N' },
      { name: '苄胺', symbol: 'C9H8N' },
      { name: '异丁酸苄酯', symbol: 'C11H14O2' },
      { name: '甲酸苄酯', symbol: 'C8H8O2' },
      { name: '氯化苄', symbol: 'C7H7Cl' },
      { name: '苯甲醇', symbol: 'C7H8O' },
      { name: '乙酸苄酯', symbol: 'C9H10O2' },
      { name: '苄氧基溴', symbol: 'C7H6BrO' },
      { name: '苯甲腈', symbol: 'C7H5N' },
      { name: '苯甲酸', symbol: 'C7H6O2' },
      { name: '苯甲醛', symbol: 'C7H6O' },
      { name: '砷烷', symbol: 'AsH3' },
      { name: '苯甲醚', symbol: 'C7H8O' },
      { name: '叔戊醇', symbol: 'C5H12O' },
      { name: '烯丙基丙基二硫', symbol: 'C6H12S2' },
      { name: '烯丙基缩水甘油醚', symbol: 'C6H10O2' },
      { name: '3-溴丙烯', symbol: 'C3H5Br' },
      { name: '乙酰乙酸烯丙酯', symbol: 'C7H10O3' },
      { name: '丙烯醛', symbol: 'C3H4O' },
      { name: '乙酰溴', symbol: 'C2H3BrO' },
      { name: '苯乙酮', symbol: 'C8H8O' },
      { name: '3-羟基-2-丁酮', symbol: 'C4H8O2' },
      { name: '乙酰胺', symbol: 'C2H5NO' },
      { name: '乙醛', symbol: 'C2H4O' },
      { name: '偏氟乙烯', symbol: 'C2H2F2' },
      { name: '玫瑰醚', symbol: 'C10H18O' },
      { name: '丙酮醛', symbol: 'C3H4O2' },
      { name: '过氧化丁酮', symbol: 'C8H18O6' },
      { name: '甲酸香茅酯', symbol: 'C11H20O2' },
      { name: '氯甲基乙醚', symbol: 'C3H7ClO' },
      { name: '2-氯乙醇', symbol: 'C2H5ClO' },
      { name: '氯丙酮', symbol: 'C3H5ClO' }
    ]
  }
];
